import { Outlet } from "react-router-dom"
import Footer from "../../components/marketing/footer/Footer"
import MarketingNav from "../../components/navigation/MarketingNav"

interface Props {
  guideOpened: any
  setGuideOpened: any
}

export default function MarketingLayout({
  guideOpened,
  setGuideOpened,
}: Props) {
  return (
    <>
      <MarketingNav guideOpened={guideOpened} setGuideOpened={setGuideOpened} />
      <Outlet />
      <Footer />
    </>
  )
}